import breadcrumbs from "@/views/modules/Opportunitys/MenuList.vue";
import lang from "@/views/modules/Opportunitys/language/en";
import loader from "@/views/shared/loading/Loading.vue";
import DateFormat from "@/plugins/date_format.js";
import Datepicker from 'vuejs-datepicker';
import vSelect from "vue-select";
import alert from "@/views/shared/notify/Alert.vue";

export default {
    name: "edit-opportunity",

    components: {
        breadcrumbs,
        loader,
        vSelect,
        Datepicker,
        alert
    },
    data() {
        return {
            loading: true,
            dataList: {
               // peer_review_timeline1:'',
                proposal_shared_date1:'',
                budget_shared_date1:'',
                peer_comment_date1:'',
                submition_date1:'',
                deadline1:'',
            },
            deadline: '',
           // peer_review_timeline: '',
            proposal_shared_date:'',
            budget_shared_date:'',
            peer_comment_date:'',
            submition_date:'',
            lang: [],
            WorkPackList: [],
            page: 1,
            search: '',
            sort: {
                order: 'desc',
                column: 'date_entered',
            },
            perPage: 10,
            loading: true,
            dataList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            WorkOpportunity_id: '',
            opportunity_id: '',
            showWorkOpportunity: false,
            linkWorkList: [
                {
                    'workpackage_name': '',
                }
            ],
            showEdit: false,
            edit: true,
            close: false,
            budget_list: [],
            showBudgetOpportunity: false,
            BudgetOpportunity_id: '',
            linkBudgetList: [],
            customLoading: false,
            usersList: [],
            inviteesList: [],
            invitee: {
                parent_type: 'Opportunitys',
                parent_id: '',
                assigned_user_id: '',
                mobile: '',
                professional: '',
                description: '',
            },
            country_array: [],
            checked_app: false,
            checked_pvt: false,
            checked_ed: false,
            reminder: {
                users: []
            },
            remindersList: [],
            relatedLinksList: [],
            related_link: {},
            dom_array: [],
            fundersList: [],
            am:'AM',
            pm:'PM',
        }
    },
    mounted() {
        this.getOpportunity();
        
        this.lang = lang;
        this.dom_array = this.domArrayVariable;

        this.getUserList();
        this.getFunderList();
        this.getCountry();
        this.getRelatedWork();
        this.getRelatedBudget(this.$route.params.id);
        this.updateNotification();
        this.loadRelatedLinks();

        let userInfo = localStorage.getItem('user_prefrence');
                let userData = (JSON.parse(userInfo));
                let timeFormat = '';
                if(userData.timeformat.includes(":")){
                    timeFormat = userData.timeformat.split(":");
                }
                if(userData.timeformat.includes(".")){
                    timeFormat = userData.timeformat.split(".");
                }
                if(timeFormat[1][1] == 'a' || timeFormat[1] == 'ia')
                {
                    this.am = 'am';
                    this.pm = 'pm';
                }if(timeFormat[1][1] == 'A' || timeFormat[1] == 'iA')
                {
                    this.am = 'AM';
                    this.pm = 'PM';
                }
                
    },
    computed: {
        hours() {
            return Array.from({ length: 12 }, (_, index) => (index + 1).toString().padStart(2, '0'));
        },
        minutes() {
            return Array.from({ length: 60 }, (_, minute) => minute.toString().padStart(2, '0'));
        },
        // When the opportunity's Funding Type is "Researcher Recognition", hide the
        // Budget Cap, Duration and Peer Review Timeline rows on detail/edit.
        isResearcherRecognition() {
            return this.dataList && this.dataList.opportunity_type === 'Researcher Recognition';
        }
    },
    methods: {
        async updateNotification() {
            const self = this;
            self.loading = true;
            let postData = {
                parent_id: self.$route.params.id,
                parent_type: 'Opportunitys',
            }
            await axios.post('api/modules/notifications/read-notification', postData).then(function (response) {
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        async getOpportunity() {
            const self = this;
            self.loading = true;
            self.opportunity_id = self.$route.params.id;
            window.currentAction = 'view';
                await axios.get('api/modules/opportunitys/' + self.$route.params.id).then(function (response) {
                self.dataList = response.data;
                self.deadline = self.dataList.deadline;
                //self.peer_review_timeline = self.dataList.peer_review_timeline;
                self.proposal_shared_date = self.dataList.proposal_shared_date;
                self.budget_shared_date = self.dataList.budget_shared_date;
                self.peer_comment_date = self.dataList.peer_comment_date;
                self.submition_date = self.dataList.submition_date;
                if (self.dataList.app_allowed == 'Yes') {
                    self.checked_app = true;
                    self.dataList.app_allowed = 1;
                } else {
                    self.checked_app = false;
                    self.dataList.app_allowed = 0;
                }

                if (self.dataList.opportunity_Private == 'Yes') {
                    self.checked_pvt = true;
                    self.dataList.opportunity_Private = 1;
                } else {
                    self.checked_pvt = false;
                    self.dataList.opportunity_Private = 0;
                }

                if (self.dataList.is_ed_support == 'Yes') {
                    self.checked_ed = true;
                    self.dataList.is_ed_support = 1;
                } else {
                    self.checked_ed = false;
                    self.dataList.is_ed_support = 0;
                }


                self.loading = false;
                
            }).catch(function () {
                self.loading = false;
            });
        },
        deleteProduct() {
            const self = this;
            window.currentAction = 'delete';
            axios.delete('api/modules/opportunitys/' + self.$route.params.id).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/products');
            }).catch(function () {
                self.loading = false;

            });
        },
        getWorkPackage(opportunity_id) {
            const self = this;
            self.showWorkOpportunity = true;
            $("#workPackModal").modal("show");
            let searches = {
                status: {
                    key: 'statuc',
                    value: 'Active'
                }
            }
            self.customLoading = 'funder';
             window.currentAction = 'list';
                axios.get('api/modules/getWorkPack', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: searches,
                    perPage: 1000,///self.perPage
                    'opprtunity_id': opportunity_id
                }
            }).then(function (response) {
                self.WorkPackList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getWorkPackage();
                } else {
                    self.loading = false;
                }

            })
        },
        setWorkPack(workid, event) {
            const self = this;
            if (workid != self.WorkOpportunity_id && self.WorkOpportunity_id != '') {
                document.getElementById('workPackLink_' + self.WorkOpportunity_id).checked = false;
            }
            if (event.target.checked) {
                self.WorkOpportunity_id = workid;
            } else {
                self.WorkOpportunity_id = '';
            }

        },
        AddWorkPackage() {
            const self = this;
            let opportunity_id = document.getElementById("opportunity_id").value;
            window.currentAction = 'edit'
            axios.post('api/modules/addworkpackage', { 'opportunity_id': opportunity_id, 'workpackage_id': self.WorkOpportunity_id }).then(function (response) {
                self.getRelatedWork();
                self.showWorkOpportunity = false;
                $("#workPackModal").modal("hide");
            });
        },
        getRelatedWork(ShowDetail = 0) {
            const self = this;
            window.currentAction = 'detail';
                axios.get('api/modules/getworkopportunity', { params: { 'opportunity_id': self.opportunity_id } }).then(function (response) {
                self.linkWorkList = response.data;
                if (ShowDetail == 1) {
                    $("#workPackDetailModal").modal("show");
                }
            }).catch(function () {
                //self.loading = false;
                console.log("Error")
            });
        },

        GetDisplayDate(date) {
            const date_format = new DateFormat("dd/MM/yyyy");
            return date_format.changeDateFormat(date);
        },
        editEnable(chk) {
            const self = this;
            if (chk == 'edit') {
                self.showEdit = true;
                self.edit = false;
                self.close = true;
            } else {
                self.updateColumn();
            }

        },
        updateColumn() {
            const self = this;
            let opportunity_title = document.getElementById("opportunity_title").value;
            let opportunity_type = document.getElementById("opportunity_type").value;
            let opportunity_funder = document.getElementById("opportunity_funder").value;
            let country_id = document.getElementById("country_id").value;
            let currency_name = '';
            let opportunity_year = 1;
            let opportunity_budget = '';
            if(!self.isResearcherRecognition){
                currency_name = document.getElementById("currency_name").value;
                opportunity_year = document.getElementById("opportunity_year").value;
                opportunity_budget = document.getElementById("opportunity_budget").value;
            }            
            let opportunity_scope = document.getElementById("opportunity_scope").value;
            let opportunity_funder_link = document.getElementById("opportunity_funder_link").value;
            let status = document.getElementById("status").value;
            let deadline = "";
            if(document.getElementById("deadline").value != "")
            {
                deadline = document.getElementById("deadline").value;
            }else{
                deadline = self.deadline;
            }

           /*  let peer_review_timeline = "";
            if(document.getElementById("peer_review_timeline").value != "")
            {
                peer_review_timeline = document.getElementById("peer_review_timeline").value;
            }else{
                peer_review_timeline = self.peer_review_timeline;
            } */

            let proposal_shared_date = "";
            if(!self.isResearcherRecognition && document.getElementById("proposal_shared_date").value != "")
            {
                proposal_shared_date = document.getElementById("proposal_shared_date").value;
            }else{
                proposal_shared_date = self.proposal_shared_date;
            }

            let budget_shared_date = "";
            if(!self.isResearcherRecognition && document.getElementById("budget_shared_date").value != "")
            {
                budget_shared_date = document.getElementById("budget_shared_date").value;
            }else{
                budget_shared_date = self.budget_shared_date;
            }

            let peer_comment_date = "";
            if(!self.isResearcherRecognition && document.getElementById("peer_comment_date").value != "")
            {
                peer_comment_date = document.getElementById("peer_comment_date").value;
            }else{
                peer_comment_date = self.peer_comment_date;
            }

            if (self.isResearcherRecognition) {
                const today = moment().format('DD/MM/yyyy');
                currency_name = 'NA';
                opportunity_budget = '0';
                opportunity_year = '0';
                proposal_shared_date = today;
                budget_shared_date = today;
                peer_comment_date = today;
                submition_date = today;
            }

            let submition_date = "";
            if(!this.isResearcherRecognition && document.getElementById("submition_date").value != "")
            {
                submition_date = document.getElementById("submition_date").value;
            }else{
                submition_date = self.submition_date;
            }
          
            let app_allowed = 0;
            if ($("#app_allowed").is(":checked")) {
                app_allowed = 1;
            } else {
                app_allowed = 0;
            }

            let opportunity_Private = 0;
            if ($("#opportunity_Private").is(":checked")) {
                opportunity_Private = 1;
            } else {
                opportunity_Private = 0;
            }

            let is_ed_support = 0;
            if ($("#is_ed_support").is(":checked")) {
                is_ed_support = 1;
            } else {
                is_ed_support = 0;
            }

            // let app_status = document.getElementById("status").value;
            let formData = {
                'opportunity_id': self.$route.params.id,
                'opportunity_title': opportunity_title,
                'opportunity_scope':opportunity_scope,
                'opportunity_type': opportunity_type,
                'opportunity_funder': self.dataList.opportunity_funder,
                'opportunity_funder_link':opportunity_funder_link,
                'country_id': country_id,
                'currency_name':currency_name,
                'opportunity_budget': opportunity_budget,
                'opportunity_year': opportunity_year,
                'deadline': deadline,
               // 'peer_review_timeline': peer_review_timeline,
                'proposal_shared_date': proposal_shared_date,
                'budget_shared_date': budget_shared_date,
                'peer_comment_date': peer_comment_date,
                'submition_date': submition_date,
                'app_allowed': app_allowed,
                'opportunity_Private': opportunity_Private,
                'is_ed_support': is_ed_support,
                'status': status,
            }
            window.currentAction = 'edit'
            axios.post('api/modules/update_opportunity', formData).then(function (response) {
                self.showEdit = false;
                self.edit = true;
                self.close = false;
                self.getOpportunity();
            }).catch(error => {
                    self.loading = false;
                    self.process = false;
                    self.disabled = false;
                    let allerror = document.getElementsByClassName('error');
                    for(let i = 0; i < allerror.length; i++)
                    {
                        allerror[i].innerHTML = '';
                    }
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                        
                        let error_el = document.getElementById(key+"_error");
                            error_el.innerHTML = errorval
                    });
                    localStorage.removeItem('Errors');
            })
        },
        getAllTemplate(Opportunity_years) {
            const self = this;
            self.showBudgetOpportunity = true;
            $("#budgetkModal").modal("show");
             window.currentAction = 'list';
                axios.get('api/modules/getbudgettemplate', { params: { 'opportunity_year': Opportunity_years } }).then(function (response) {
                self.budget_list = response.data.items;

            })
        },
        setBudget(budgetid, event) {
            const self = this;
            if (budgetid != self.BudgetOpportunity_id && self.BudgetOpportunity_id != '') {
                document.getElementById('budgetLink_' + self.BudgetOpportunity_id).checked = false;
            }
            if (event.target.checked) {
                self.BudgetOpportunity_id = budgetid;
            } else {
                self.BudgetOpportunity_id = '';
            }
        },
        AddBudgetTemplate() {
            const self = this;
            let opportunity_id = document.getElementById("opportunity_id").value;
            window.currentAction = 'edit'
            axios.post('api/modules/addbudget', { 'opportunity_id': opportunity_id, 'template_id': self.BudgetOpportunity_id }).then(function (response) {

                self.showBudgetOpportunity = false;
                $("#budgetkModal").modal("hide");
                self.getRelatedBudget(opportunity_id);
            });
        },
        getRelatedBudget(opportunity_id) {
            const self = this;
            window.currentAction = 'detail';
            axios.get('api/modules/linkbudget', { params: { 'opportunity_id': opportunity_id } }).then(function (response) {
                self.linkBudgetList = response.data.items;
            })
        },
        loadInvitees() {
            const self = this;
            let searches = {
                parent_type: {
                    key: 'parent_type',
                    value: 'Opportunitys'
                },
                parent_id: {
                    key: 'parent_id',
                    value: self.$route.params.id
                }
            }
            self.customLoading = 'invitee';
             window.currentAction = 'list';
                axios.get('api/modules/invitees', { params: { search: searches, perPage: '999999999999' } }).then(function (response) {
                self.inviteesList = response.data.items;
                self.customLoading = false;
            }).catch(function(){
                self.customLoading = false;
            })
        },
        addInvitees() {
            const self = this;
            let parent_id = self.$route.params.id;
            window.currentAction = 'edit'
            axios.post('api/modules/invitees', { 'editFormData': self.invitee, 'parent_id': parent_id }).then(function (response) {

                self.invitee.parent_id = '';
                self.invitee.assigned_user_id = '';
                self.invitee.mobile = '',
                    self.invitee.professional = '';
                self.invitee.description = '';
                self.invitee.users = [];

                self.customLoading = false;
                $("#inviteeModal").modal("hide");

                self.loadInvitees();

            }).catch(function(){
                self.customLoading = false;
            })
        },
        deleteInvitee(recordId) {
            const self = this;
            self.customLoading = 'invitee';
            window.currentAction = 'delete'
            const deleteRecord = { 'delete_id': recordId };
            axios.post('api/modules/invitees/remove', deleteRecord).then(function () {
                self.customLoading = false;
                self.loadInvitees();
            }).catch(function(){
                self.customLoading = false;
            });
        },
        async getUserList() {
            const self = this;
            let searches = {};
            window.currentAction = 'detail';
            
            await axios.post('api/modules/users/select').then(function (response) {
                self.usersList = response.data.items.map(item => ({
                    id: item.id,
                    // display_name = "Full Name (email)" from the backend; keep the
                    // same shape both reminder panels use.
                    name: item.display_name || `${item.name} (${item.email})`,
                }));
            }).catch(function(){
                self.customLoading = false;
            })
        },
        async getCountry() {
            const self = this;
             window.currentAction = 'detail';
            await axios.get('api/modules/getcountrylists', { 'all_country': true }).then(function (response) {
                self.country_array = response.data;
            }).catch(function(){
                self.customLoading = false;
            })
        },
        customFormatter(date) {
            
            return moment(date).format('DD/MM/yyyy');
        },
        showData(useDate) {
            let dateFormat = new DateFormat('DD/MM/yyyy');

            return dateFormat.getDateFormat(useDate);
        },

        handleReminderTypeChange() {
            if (this.reminder.reminder_type !== 'On Due Date') {
                this.reminder.reminder_date = ''; // Clear the reminder date value
            }
        },
        formatTime(hours, minutes, period) {
            const p = String(period).toUpperCase();
            if (p !== 'AM' && p !== 'PM') {
                throw new Error('Invalid AM/PM value: ' + period);   // never default silently to PM
            }
            return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':00' + p;
        },
        saveReminder() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;
            self.customLoading = 'reminder';
            self.reminder.parent_type = 'Opportunitys';
            self.reminder.parent_id = self.$route.params.id;
            self.reminder.reminder_time = self.formatTime(self.reminder.hours, self.reminder.minutes, self.reminder.period);
            window.currentAction = 'edit'
            axios.post('api/modules/reminders', self.reminder).then(function (response) {
                self.customLoading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.reminder = {};
                self.loadReminders();
                // self.reminder.users = [];
            }).catch(function (response) {
                self.customLoading = false;

                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
        loadReminders() {
            const self = this;
            let searches = {
                parent_type: {
                    key: 'parent_type',
                    value: 'Opportunitys'
                },
                parent_id: {
                    key: 'parent_id',
                    value: self.$route.params.id
                }
            }
            self.customLoading = 'reminder';
             window.currentAction = 'list';
                axios.get('api/modules/reminders', { params: { search: searches } }).then(function (response) {
                self.remindersList = response.data.items;
                self.customLoading = false;
            })
        },
        deleteReminder(recordId) {
            const self = this;
            self.customLoading = 'reminder';
            const deleteRecord = { 'delete_id': recordId };
            window.currentAction = 'delete'
            axios.post('api/modules/reminders/remove', deleteRecord).then(function () {
                self.customLoading = false;
                self.loadReminders();
            }).catch(function(){
                self.customLoading = false;
            });
        },
        addRelatedLink() {
            const self = this;
            let formData = {
                'parent_type': 'Opportunitys',
                'parent_id': self.$route.params.id,
                'name': self.related_link.title,
                'description': self.related_link.link,
            }
            if (self.related_link.link === '' || self.related_link.tile === '') {
                self.$refs.notifyMsg.showAlert('Error','link & title can not be empty');
                return false;
            }

            self.customLoading = 'addRelatedLink';
            window.currentAction = 'edit'
            axios.post('api/modules/relatedLinks', { editFormData: formData }).then(function (response) {
                self.related_link = {};
                $("#relativeLinkModal").modal("hide");
                self.loadRelatedLinks();
                self.customLoading = false;
            }).catch(function(){
                self.customLoading = false;
            })
        },
        async loadRelatedLinks() {
            const self = this;
            let searches = {
                parent_type: {
                    key: 'parent_type',
                    value: 'Opportunitys'
                },
                parent_id: {
                    key: 'parent_id',
                    value: self.$route.params.id
                }
            }
            self.customLoading = 'relatedLink';
            window.currentAction = 'detail';
            await axios.get('api/modules/relatedLinks', { params: { search: searches } }).then(function (response) {
                self.relatedLinksList = response.data.items;
                self.customLoading = false;
            }).catch(function(){
                self.customLoading = false;
            })
        },
        isAbsoluteURL(url) {
            return /^(https?:\/\/)|^(\/\/)/.test(url);
        },

        openLink(url){
            let result = url.includes("http");
            if(result == true){
                window.open(url);
            }else{
            window.open('http://'+url);
            }
        },

        breakLine(str){
            return str.replace(/\n/g, "<br/>")
        },
        async getFunderList() {
            const self = this;
            let searches = {
                status: {
                    key: 'statuc',
                    value: 'Active'
                }
            }
            self.customLoading = 'funder';
            await axios.get('api/modules/funders', { params: { search: searches,callingFrom: 'form' } }).then(function (response) {
                self.fundersList = response.data.items.map(item =>  `${item.name}`);
                self.customLoading = false;
            })
        },
        cleanString(userStr){
            return userStr.replace(/[\[\]"]/g, '');
        },
        removeBR(str){
            return str.replace(/<br\s*\/?>/gi, '\n')
        }
    }
}